// VIBRANIAM-SPACE v2 - particle-utils.js
// Small helpers shared by the UI. The WASM loading lives in engine/wasm.js and
// the buffer plumbing in engine/substrates/, so this file stays presentational.

export function smoothTowards(current, target, coeff, dt) {
  const k = 1 - Math.exp(-coeff * dt);
  return current + (target - current) * k;
}

export function hsvToHex(h, s, v) {
  h -= Math.floor(h);
  const i = Math.floor(h * 6);
  const f = h * 6 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  let r, g, b;
  switch (i % 6) {
    case 0: r = v; g = t; b = p; break;
    case 1: r = q; g = v; b = p; break;
    case 2: r = p; g = v; b = t; break;
    case 3: r = p; g = q; b = v; break;
    case 4: r = t; g = p; b = v; break;
    default: r = v; g = p; b = q; break;
  }
  const to = (x) => Math.round(Math.max(0, Math.min(1, x)) * 255).toString(16).padStart(2, '0');
  return `#${to(r)}${to(g)}${to(b)}`;
}

export function formatBytes(n) {
  if (!Number.isFinite(n)) return '-';
  const u = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(i ? 1 : 0)} ${u[i]}`;
}

export function formatCount(n) {
  if (!Number.isFinite(n)) return '-';
  if (n >= 1000000) return `${(n / 1000000).toFixed(2)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(0)}k`;
  return String(Math.round(n));
}

/** Reads a File into a mono Float32Array using the Web Audio decoder. */
export async function decodeAudioFileToMono(file, targetContext) {
  const ctx = targetContext || new (window.AudioContext || window.webkitAudioContext)();
  const audioBuffer = await ctx.decodeAudioData(await file.arrayBuffer());
  const channels = audioBuffer.numberOfChannels;
  const out = new Float32Array(audioBuffer.length);
  for (let c = 0; c < channels; c++) {
    const data = audioBuffer.getChannelData(c);
    for (let i = 0; i < data.length; i++) out[i] += data[i] / channels;
  }
  return { samples: out, sampleRate: audioBuffer.sampleRate, duration: audioBuffer.duration, audioBuffer };
}
